import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { login } from '@/auth/services/auth-service';
import { AuthError } from '@/shared/errores/auth-error';

export function useLoginMutatio() {
  const { message } = App.useApp();
  return useMutation({
    mutationFn: login,
    onSuccess: () => {},
    onError: (error) => {
      if (error instanceof AuthError) {
        message.error(error.message);
      } else {
        message.error('Error de conexión con el servidor. Inténtalo más tarde.');
      }
    },
  });
}
